import DataSourceRegistry from './framework2-sdk/dataSourceRegistry';

export default new DataSourceRegistry();
